import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const PageContext = createContext();

const PageProvider = ({ children, value }) => {
  const { location, pageContext } = value;
  const [pathname, setPathname] = useState(location.pathname);
  const [prevPathname, setPrevPathname] = useState('');

  React.useEffect(() => {
    setPrevPathname(pathname);
    setPathname(location.pathname);
  }, [location.pathname]);

  return (
    <PageContext.Provider
      value={{
        pathname,
        prevPathname,
        location,
        pageContext,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

PageProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    pageContext: PropTypes.shape({}),
  }).isRequired,
};

export { PageContext as default, PageProvider };
